import React from "react";
import { StyleSheet, View } from "react-native";
type Props = {
  style?: any;
  children?: React.ReactChild | React.ReactChild[];
};
export default function FormGroup(props: Props) {
  return <View {...props} style={[styles.formGroup, props.style]} />;
}
const styles = StyleSheet.create({
  formGroup: {
    width: "100%",
    padding: 5,
  },
});
